import { Message } from "../../types";
import {
  isMessageFile,
  isMessageText,
  isMessageButtons,
} from "../../type-guards";
import {
  ChatMessageText,
  ChatMessageFile,
  ChatMessageButtons,
} from "../message-kinds";
import styles from "./chat-message.module.scss";

type Props = {
  message: Message;
};

export const ChatMessageContent = ({ message }: Props) => {
  if (isMessageButtons(message)) {
    return <ChatMessageButtons message={message} className={styles.content} />;
  }

  if (isMessageFile(message)) {
    return <ChatMessageFile message={message} className={styles.content} />;
  }

  if (isMessageText(message)) {
    return <ChatMessageText message={message} className={styles.content} />;
  }

  return null;
};
